"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardShell_1 = require("./CardShell");
exports.default = CardShell_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CardShell/index.js
// module id = 1752
// module chunks = 8